import { BaseService } from '@/modules/Core/services/BaseService'
import type { IMediMedicamentos, ITiposGeneralMedicamentos } from '@/modules/Farmacia/interfaces'
import type { ICitaAdmision } from '@/modules/Admision/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { ICargaMedicamentosPayload, CargaMedicamentosResponse } from '../interfaces/ICargaLotes'
import type { IMediTipoInventario } from '../interfaces/tablas/IMediMedicamentosGenericos'
import type { IMediMedicamentosForm } from '../interfaces/tablas/IMediMedicamentos'

export interface IInventarioDashboardCounts {
  vigencia: { apto: number; priorizar: number; noDispensar: number; vencido: number }
  stock: { enExistencia: number; prontoAgotarse: number; agotado: number }
}

export class MedicamentoService extends BaseService<IMediMedicamentos> {
  constructor () {
    super({
      baseUrl: 'medicines/medicines/'
    })
  }
  async getTiposGenerales (): Promise<
    AxiosResponse<IResponseApi<ITiposGeneralMedicamentos>>
  > {
    return this.http.get<IResponseApi<ITiposGeneralMedicamentos>>(`/general`)
  }
  async createExterna (data: ICitaAdmision): Promise<AxiosResponse<IResponseApi<IMediMedicamentos>>> {
    return this.http.post<IResponseApi<IMediMedicamentos>>(`/create-externa`, data).catch(this.errorHandle)
  }
  async cargaMasiva (data: ICargaMedicamentosPayload[], tipo: IMediTipoInventario): Promise<AxiosResponse<IResponseApi<CargaMedicamentosResponse>>> {
    return this.http.post<IResponseApi<CargaMedicamentosResponse>>(`/carga-masiva/${tipo}`, data).catch(this.errorHandle)
  }
  async validarCargaMasiva (data: ICargaMedicamentosPayload[], tipo: IMediTipoInventario): Promise<AxiosResponse<IResponseApi<CargaMedicamentosResponse>>> {
    return this.http.post<IResponseApi<CargaMedicamentosResponse>>(`/validar-carga-masiva/${tipo}`, data).catch(this.errorHandle)
  }
  async getMedicinesWithExistingBatches (): Promise<AxiosResponse<IResponseApi<IMediMedicamentos[]>>> {
    return this.http.get<IResponseApi<IMediMedicamentos[]>>(`/getMedicinesWithExistingBatches`).catch(this.errorHandle)
  }
  async deleteMedicamento<T>(id: number): Promise<AxiosResponse<IResponseApi<T>>> {
    return this.http.delete<IResponseApi<T>>(`/delete/${id}`).catch(this.errorHandle)
  }
  async sincronizar(tipo: IMediTipoInventario): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<IResponseApi<string>>(`/sincronizar/${tipo}`).catch(this.errorHandle)
  }
  async generateExcelList(tipo: IMediTipoInventario): Promise<AxiosResponse<ArrayBuffer>> {
      return this.http.get<ArrayBuffer>(`/generate-excel-list/${tipo}`, {
        responseType: 'arraybuffer',
        headers: {
          'Access-Control-Max-Age': '0'
        }
      })
    } 
  async cargaMasivaMedicamentos (data: IMediMedicamentosForm[]): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<IResponseApi<string>>(`/carga-masiva-medicamentos`, data).catch(this.errorHandle)
  }
  async validarCargaMasivaMedicamentos (data: IMediMedicamentosForm[]): Promise<AxiosResponse<IResponseApi<CargaMedicamentosResponse>>> {
    return this.http.post<IResponseApi<CargaMedicamentosResponse>>(`/validar-carga-masiva-medicamentos`, data).catch(this.errorHandle)
  }
  async getInventarioDashboard (mediTipo: IMediTipoInventario): Promise<AxiosResponse<IResponseApi<IInventarioDashboardCounts>>> {
    return this.http.get<IResponseApi<IInventarioDashboardCounts>>(`/inventario-dashboard`, { params: { mediTipo } }).catch(this.errorHandle)
  }
}
